import * as FiIcons from 'react-icons/fi';

export const roleIcons = {
  agent: FiIcons.FiBriefcase,
  recruiter: FiIcons.FiUserPlus,
  trainer: FiIcons.FiBookOpen,
  admin: FiIcons.FiShield
};

export const navIcons = {
  home: FiIcons.FiHome,
  training: FiIcons.FiPlayCircle,
  resources: FiIcons.FiFolder,
  onboarding: FiIcons.FiCheckSquare,
  invitations: FiIcons.FiMail,
  upload: FiIcons.FiUploadCloud,
  myContent: FiIcons.FiFileText,
  users: FiIcons.FiUsers,
  settings: FiIcons.FiSettings,
  profile: FiIcons.FiUser
};